import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, BehaviorSubject, ReplaySubject } from "rxjs";
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from "@angular/common/http";

import { AppService } from '../app.service';
import { UserService } from '../user/user.service';
import { LaravelApiService } from '../laravel.service';

import { Organization } from './organization.model';
import { User } from '../user/user.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends AppService {

  private _subOrgs: Organization[] = [];
  public subOrgsSubject: Subject<Organization[]>;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private laravel: LaravelApiService
  ) {
    super();

    this.subOrgsSubject = new BehaviorSubject(this._subOrgs);
    this.getSubOrgs(this.userService.userInfo.user_group[0].id);

    this.userService.tempOrgIDSubject.subscribe((orgID) => {
      if(orgID) {
        this.getSubOrgs(orgID);
      }
    })
  }

  update() {
    this.subOrgsSubject.next(this._subOrgs);
  }

  get subOrgs(): Organization[] {
    return this._subOrgs;
  }

  getSubOrgs(orgId: number) {
    this.laravel.fetch('user/sub_orgs', orgId)
      .subscribe((subOrgs) => {
        if (subOrgs) {
          this._subOrgs = subOrgs.map((subOrg) => new Organization(subOrg));
          this.update()
        }
      });
  }

  organization(id: number, update?: boolean): Organization {
    if (update) {
      let orgSub = this.laravel.fetch("user/acl/group", id);
      orgSub.subscribe( (org) => {
        if (!org) return;

        this.updateOrganization(org);
      })
    }

    return this._find('subOrgs', id);
  }

  updateOrganization(organization) {
    let organizationRef = this._find('subOrgs', organization.id);
    organizationRef = Object.assign(organizationRef, organization);
    this._update('subOrgs', organization);
    this.update();
  }

  getOrgUsers(id: number) {
    let userSub = this.laravel.list(`user/acl/${id}/user`);
    userSub.subscribe( (users) => {
      console.log(users)
      if (users) this.updateOrgUsers(users, id);
    })
  }

  updateOrgUsers(users, orgId) {
    users = users.map((user) => new User(user));
    let organization = this._find('subOrgs', orgId);
    organization.users = users;
    this.updateOrganization(organization);
  }

  getUser(userId: number) {
    return this.laravel.fetch('user/profile', userId);
  }

  createUser(user) {
    user.action = 'create';
    return this.laravel.create(`user/acl/${user.group.id}/user`, user)
  }

  updateUser(user) {
    user.action = 'update';
    return this.laravel.update(`user/acl/${user.group.id}/user`, user.id, user)
  }

  public getVPNConfig(userId){
    return this.laravel.fetch_resource('user/config/vpn', userId);
  }

  createOrg(org) {
    return this.laravel.create(`user/acl/group`, org)
  }

  updateOrg(org) {
    return this.laravel.update(`user/acl/group`, org.id, org)
  }

}
